// import React, { useEffect, useState } from 'react';
import { HeroPage } from "../../components/sections/partner/HeroPage";
import Products from "../../components/sections/partner/Products";
import Interest from "../../components/sections/partner/Interest";
import Why from "../../components/sections/partner/Why";
import { Faq } from "../../components/sections/partner/Faq";
import useDataFormModal from "../../hooks/useDataFormModal";
import DataFormModal from "../../components/common/DataFormModal";
import { useLocation } from "react-router-dom";

const Partner = () => {
  // Inside your component:
  const { isModalOpen, closeModal } = useDataFormModal();
  const location = useLocation();
  const partnerDetails = location.state?.partnerDetails || {};

  const data = partnerDetails.data;

  return (
    <>
      {/* <Hero data={partnerData.hero} /> */}
      <HeroPage data={data} />
      <Products data={data} />
      <Interest data={data} />
      <Why data={data} />
      <Faq data={data} />

      {/* Data Form Modal */}
      <DataFormModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Partner;
